import { ReactNode } from "react";

interface BotaoProps {
  texto?: any,
  id?: string,
  url?: string,
  active? : boolean,
  icon?: ReactNode
  className?: string,
  onClick?: () => void
  search? : boolean
  type?: "button" | "submit" | "reset" |undefined 
  disabled?: boolean
}

export function Botao({ texto, id, active, icon, className, onClick, search, type, disabled } : BotaoProps) {
  return (
    <>
      <div className="flex flex-row items-center">
        {(icon && search) && <div className="flex flex-row border rounded bg-gray-6 justify-center items-center p-2">{icon}</div>}
        {
        texto && 
          <button 
            id={id && id}
            className={`py-2 px-4 gap-3 relative inline-flex items-center rounded border  
              ${className} 
              ${ active && 'text-white bg-[#316CF4]'}`
            }
            onClick={onClick}
            type={type}
            disabled={disabled}
          >
            {icon}{texto}
          </button>
        }
        {
          !texto && 
            <button 
              className={`py-2 px-4 gap-3 relative inline-flex items-center rounded border  
                ${className}
                ${ active && 'text-white bg-[#316CF4]'}`
              }
              onClick={onClick}
              type={type}
            >
              {icon}
            </button>
        }
        
      </div>
    </>
  );
}
